<template>
    <div class="row">
        <div :class="transaction.flowStatus.flowStepStatusId == 21 && !$store.state.userData.isOrganization ? 'col-md-9' : 'col-12'">
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات کلی</div>
                <div class="card-body">
                    <Loading v-if="showLoading" />
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details">
                            <tbody>
                                <tr>
                                    <td v-if="transaction.domainData">نام مشتری:</td>
                                    <td v-if="transaction.domainData">{{ transaction.domainData.fullName }}</td>
                                    <td>مبلغ:</td>
                                    <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount) }} ریال</td>
                                    <td>مبلغ نهایی:</td>
                                    <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.totalAmount) }} ریال</td>
                                </tr>
                                <tr>
                                    <td>میزان تخفیف:</td>
                                    <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.discount) }} ریال</td>
                                    <td>وضعیت:</td>
                                    <td>{{ transaction.flowStatus.flowStepStatus.title }}</td>
                                    <td>تاریخ:</td>
                                    <td>{{ transaction.createdAtPersian }}</td>
                                </tr>
                                <tr v-if="transaction.description">
                                    <td>توضیحات:</td>
                                    <td colspan="5" style="border-left-color: #262644">{{ transaction.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3" v-if="transaction.flowStatus.flowStepStatusId == 21 && !$store.state.userData.isOrganization">
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات</div>
                <div class="card-body">
                    <Loading v-if="showLoading" />
                    <button class="btn btn-success btn-block" @click="confirmTransaction">تایید مالی تراکنش</button>
                    <button class="btn btn-danger btn-block" data-target="#finance-reject" data-toggle="modal">عدم تایید مالی</button>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="finance-reject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">علت عدم تایید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="description"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="financialReject" data-dismiss="modal">ثبت عدم تایید</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransactionsShow',
    data(){
        return {
            showLoading: false,
            transaction: {},
            description: ''
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Bonus/Request?RequestId=' + this.$route.params.id).then(({data}) => {
                this.transaction = data.result;
            });
        },
        confirmTransaction(){
            this.showLoading = true;
            const postedData = {
                requestId: parseInt(this.$route.params.id),
                confirm: true
            };
            this.$api.post('Organizations/Bonus/Request/FinancialApprove',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تایید مالی درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        financialReject(){
            this.showLoading = true;
            const postedData = {
                requestId: parseInt(this.$route.params.id),
                confirm: false,
                description: this.description
            };
            this.$api.post('Organizations/Bonus/Request/FinancialApprove',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'عدم تایید مالی درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>